import React from "react";

function FooterComponent() {
  const customVersion =
    process.env.REACT_APP_BUILD_VERSION || "Unknown Version";
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 10,
          // position:'absolute',
          width: "100%",
          fontSize: 14,
        }}
        className="footer"
      >
        v{customVersion}{" "}
      </div>
      {/* SIFO VERSION 0.001 */}
    </div>
  );
}

export default FooterComponent;

{
  /* <style>
{`
  .footer {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: end;
    margin-right: 45px;
    /* background: red; */
}
// `}
// </style> */}
